import React, {useEffect, useState} from 'react';
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { addUrl } from '../histori/HistoriSlice';
import { motion } from 'framer-motion';

const PokemonBattleCard = ({ name, src ,abilitis,winChance,types}) => {
    const dispatch = useDispatch();
    const [bgColor,setBgColor] = useState()
    useEffect(() => {
        if (Array.isArray(types) && types.length > 0) {
            const type = types[0].type.name
            switch(type) {
                case "normal": setBgColor("text-gray-500"); break;
                case "fighting": setBgColor("text-amber-700"); break;
                case "flying": setBgColor("text-sky-400"); break;
                case "poison": setBgColor("text-purple-700"); break;
                case "ground": setBgColor("text-amber-500"); break;
                case "rock": setBgColor("text-gray-600"); break;
                case "bug": setBgColor("text-green-900"); break;
                case "ghost": setBgColor("text-purple-950"); break;
                case "steel": setBgColor("text-gray-500"); break;
                case "fire": setBgColor("text-orange-400"); break;
                case "water": setBgColor("text-blue-500"); break;
                case "grass": setBgColor("text-green-500"); break;
                case "electric": setBgColor("text-yellow-300"); break;
                case "psychic": setBgColor("text-pink-400"); break;
                case "ice": setBgColor("text-sky-100"); break;
                case "dragon": setBgColor("text-sky-700"); break;
                case "dark": setBgColor("text-gray-900"); break;
                case "fairy": setBgColor("text-purple-300"); break;
                default: setBgColor("text-black"); break;
            }
        }
    }, [types]);

    return (
        <Link to={`/pokemons/${name}`} onClick={() => (localStorage.setItem(0,"/pokemons/Calc"))}>

            <motion.div
                initial={{ opacity: 0, y: -20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 2, ease: 'easeOut' }}
                whileHover={{ scale: 1.05    }}
                viewport={{ once: false, amount: 0.3 }}
                className={`border rounded-lg shadow-md font-mono min-h-80 max-h-80 p-4 mb-8 min-w-56 max-w-56 flex flex-col items-center text-center space-y-2 `}>

                <h2 className="text-lg font-semibold capitalize">{name}</h2>

                <img
                    src={src}
                    alt="data not found"
                    className="capitalize font-bold text-2xl w-24 h-24 object-contain hover:animate-spin"
                />
                <ul className="list-disc list-none ">
                    {abilitis.map((item, i) => (
                        <li key={i} className={"text-blue-400"}>
                                {item.ability.name}
                        </li>
                    ))}
                </ul>
                <ul>
                    <li className={bgColor}>{types[0].type.name}</li>
                </ul>
                <h2 className={""}>{winChance}% win chance</h2>
            </motion.div>
        </Link>
    );
};

export default PokemonBattleCard;
